import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementGeofencesData } from "./constants";
import type { EngagementGeofencesDataParams, GeofencesDataResponse } from "./types";

export const getEngagementGeofencesData = reactQueryFetcherAdapter(
  engagementGeofencesData,
  (signal: AbortSignal, params: EngagementGeofencesDataParams): Promise<GeofencesDataResponse> => {
    const id = params.location_set_id;
    return fetch(`/engagement/geofences_data${id ? `/${id}` : ""}`, "GET", params, { signal });
  }
);
